module.exports = __webpack_public_path__ + "static/media/TN-Women-Pants.e9d31904.svg";